import { Component } from '@ecs/Component';

export class UIElement implements Component {
  readonly type = 'UIElement';
  
  constructor(
    public elementId: string,
    public value: string | number,
    public isDirty: boolean = true
  ) {}
}